import { __assign } from "tslib";
import { connect } from 'react-redux';
import { assign, partial } from 'lodash-es';
import Screen from '../components/Screen';
import { getCurrentScreenProps } from '../selectors/screen';
import { getScreenStyles } from '../selectors/layout';
import { flashHotspots, screenTimer, screenTransitionCompleted, deselectHandoffItem, unsetScrollPos, missedClick, missClick, } from '../actionCreators';
import { isImageLoading } from '../selectors/imagePreloading';
import { isInHandoffMode } from '../selectors/handoff';
import controlScroll from '../hocs/controlScroll';
import { getMissedClickPosition } from '../utils/tracking';
import { isRecording } from '../selectors/replay';
import { getEventMeta } from '../utils/userTest';
function mapStateToProps(state) {
    var props = getCurrentScreenProps(state);
    var screenStyles = getScreenStyles(state, true);
    return __assign(__assign({}, props), { scrollTop: screenStyles.scrollTop, smoothScroll: state.screen.smoothScroll, isLoading: isImageLoading(state, props.id), fixBounce: state.deviceDetection.isIOS && screenStyles.isScrollableAreaScrollable, isInHandoffMode: isInHandoffMode(state), isRecording: isRecording(state), getMissedClickPosition: partial(getMissedClickPosition, state), isTransitionComplete: state.screen.isTransitionComplete.current, getEventMeta: partial(getEventMeta, state) });
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var newProps = {
        onAnimationComplete: function () {
            dispatch(screenTransitionCompleted({ isCurrent: true }));
            dispatch(screenTimer(stateProps.timer));
        },
        // TODO we need a touch handler here for missed gestures
        onClick: function (id, clickArea, event, scrollPos) {
            if (stateProps.isInHandoffMode) {
                dispatch(deselectHandoffItem());
            }
            else {
                event.stopPropagation();
                dispatch(
                // TODO this event is for Maze -- we should conditionally enable this
                missedClick(stateProps.getMissedClickPosition(id, clickArea, event), scrollPos));
                if (stateProps.isRecording) {
                    dispatch(missClick(stateProps.getEventMeta(event)));
                }
                dispatch(flashHotspots());
            }
        },
        onSetScrollEnd: function () {
            dispatch(unsetScrollPos());
        },
    };
    return assign({}, ownProps, stateProps, newProps);
}
var CurrentScreen = connect(mapStateToProps, null, mergeProps)(controlScroll(Screen));
export default CurrentScreen;
